<template>
  <Transition name="fade" mode="out-in">
    <div id="logoContainer" v-if="isDesktop">
      <img id="logo" :src="safeLogoImageUrl || defaultLogoUrl" />
    </div>
  </Transition>
  <Navbar />
  <Transition name="fade" mode="out-in">
    <div id="appContent" v-if="loadDetails">
      <Transition name="fade" mode="out-in">
        <div id="detailsBanner" v-if="currentView === 'welcome'">
          {{`Welcome${ currentUser ? (', ' + currentUser.firstName + ' ' + currentUser.lastName) : ''}`}}
        </div>
        <div id="detailsBanner" v-else-if="currentView === 'gameover'">
          {{ (allRoundsConcluded ? 'Game Over' : 'End of Round') }}
        </div>
      </Transition>
      <Transition name="fade" mode="out-in">
        <Welcome v-if="currentView === 'welcome'" />
        <!-- <Instructions v-else-if="currentView === 'instructions'" /> -->
        <Question v-else-if="currentView === 'question'" />
        <GameOver v-else-if="currentView === 'gameover'" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <LoginModal v-if="showLoginModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <LogoutModal v-if="showLogoutModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <LeaderboardModal v-if="showLeaderboardModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <HelpModal v-if="showHelpModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <UserModal v-if="showUserModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <ErrorModal v-if="showErrorModal" />
      </Transition>
    </div>
  </Transition>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import Welcome from './views/Welcome.vue'
import GameOver from './views/GameOver.vue'
import Question from './views/Question.vue'
import LoginModal from './components/LoginModal.vue'
import LogoutModal from './components/LogoutModal.vue'
import HelpModal from './components/HelpModal.vue'
import UserModal from './components/UserModal.vue'
import LeaderboardModal from './components/LeaderboardModal.vue'
import ErrorModal from './components/ErrorModal.vue'
import Navbar from './components/Navbar.vue'
import { mapGetters, mapActions } from 'vuex'
import { onValue } from 'firebase/database'
import defaultLogoUrl from './assets/img/logo.png'

export default {
  name: 'App',
  components: {
    Welcome,
    GameOver,
    Question,
    LoginModal,
    LogoutModal,
    LeaderboardModal,
    HelpModal,
    UserModal,
    ErrorModal,
    Navbar,
  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'backgroundImageUrl',
      'logoImageUrl',
      'primaryColor',
      'secondaryColor',
      'accentColor',
      'sideBannerUrl',
      'users',
      'currentUser',
      'currentQuestionID',
      'currentView',
      'currentRound',
      'showLeaderboardModal',
      'showHelpModal',
      'showLoginModal',
      'showLogoutModal',
      'showUserModal',
      'showErrorModal',
      'usersRef',
      'roundsRef',
      'operatorStateRef',
      'rounds',
      'gameEnabled',
      'activeRoundId',
      'clientWidth',
      'breakpoints',
    ]),
    isDesktop(){
      const theApp = this;
      return (theApp.clientWidth > theApp.breakpoints.tab);
    },
    // Only accept https URLs for the `:src` binding, same restriction as the background image.
    safeLogoImageUrl(){
      const theApp = this;
      return /^https:\/\//.test(theApp.logoImageUrl || '') ? theApp.logoImageUrl : '';
    },
    allRoundsConcluded(){
      const theApp = this;
      if(theApp.rounds.length === 0){
        return false;
      }
      const curTime = Math.floor(Date.now() / 1000);
      return !theApp.gameEnabled || theApp.rounds.every(round => curTime > round.endTime);
    },
  },
  methods: {
    ...mapActions([
      'onResize',
      'login',
      'logout',
      'updateUsers',
      'updateRounds',
      'updateCurrentRound',
      'updateCurrentView',
      'updateCurrentQuestionID',
      'toggleErrorModal',
      'updateErrorMessage',
      'handleWrongTypeTransition',
      'updateGameEnabled',
      'updateActiveRoundId',
    ]),
    // loadQuestion(scannedContent){
    //   const theApp = this;
    //   if(theApp.showReader && theApp.cameraPermissionGranted){
    //     let questionList = theApp.currentUser.questions.map(question => question.masterQuestionID);
    //     let potentialQuestionNumber = parseInt(scannedContent);
    //     let matchingUserQuestion = theApp.currentUser.questions.find(userQuestion => userQuestion.userQuestionID === (potentialQuestionNumber - 1));

    //     // if scanned content is valid question number and an unanswered question, load it
    //     if(questionList.includes((potentialQuestionNumber - 1)) && matchingUserQuestion && !theApp.currentUser.completedQuestions.includes(matchingUserQuestion.masterQuestionID)){
    //       theApp.toggleReaderVisibility(false);
    //       // reduce by 1 since question ID is 0 based
    //       theApp.updateCurrentQuestionID((potentialQuestionNumber - 1));
    //       theApp.updateCurrentView('question');
    //     }else{
    //       // otherwise show error & close scanner
    //       if(questionList.includes((potentialQuestionNumber - 1))){
    //         theApp.updateErrorMessage('You\'ve already answered this question!')
    //         theApp.toggleErrorModal()
    //       }else{
    //         console.log(scannedContent)
    //         theApp.updateErrorMessage(`This doesn’t appear to be a valid code for this activity.<br/>The scanned content was: ${scannedContent}`)
    //         theApp.toggleErrorModal()
    //       }
    //       theApp.toggleReaderVisibility(false);
    //     }
    //   }
    // }
    mapUsersSnapshot(usersValue){
      return Object.entries(usersValue).map(entry => {
        return {
          ...entry[1],
          id: entry[0],
          questions: entry[1].questions ? Object.entries(entry[1].questions).map(questionEntry => {
            return {
              ...questionEntry[1],
              questionRefID: questionEntry[0]
            }
          }) : [],
          viewedQuestions: entry[1].viewedQuestions ? Object.values(entry[1].viewedQuestions) : [],
          completedQuestions: entry[1].completedQuestions ? Object.values(entry[1].completedQuestions) : [],
          completedRounds: entry[1].completedRounds ? Object.values(entry[1].completedRounds) : [],
        }
      });
    },
    findActiveRoundId(rounds){
      const theApp = this;
      // Operator gate takes precedence: when disabled, no round is ever active regardless of schedule.
      if(!theApp.gameEnabled){
        return null;
      }
      // Durable operator round selection overrides the authored schedule when set.
      if(theApp.activeRoundId !== null && theApp.activeRoundId !== undefined){
        const selectedRound = rounds.find(round => round.id === theApp.activeRoundId);
        return selectedRound ? selectedRound.id : null;
      }
      const curTime = Math.floor(Date.now() / 1000);
      const activeRound = rounds.find(round => curTime >= round.startTime && curTime <= round.endTime);
      return activeRound ? activeRound.id : null;
    },
    reevaluateCurrentRound(){
      const theApp = this;
      if(theApp.rounds.length === 0){
        return;
      }
      const nextRoundId = theApp.findActiveRoundId(theApp.rounds);
      if(nextRoundId === theApp.currentRound){
        return;
      }
      theApp.updateCurrentRound(nextRoundId);
      theApp.handleWrongTypeTransition();
      if(nextRoundId === null && theApp.currentView === 'question'){
        theApp.updateCurrentView('gameover');
      }
    },
  },
  mounted(){
    const theApp = this;
    window.quizWhizApp = this;
    document.title = theApp.moduleTitle.replace(/<[^>]*>?/gm, '');
    // Only accept https URLs or a bundled-asset-relative path, and escape backslash/quote
    // so the value cannot break out of the quoted CSS url() literal. The bundled-relative
    // path must be absolutized against the document, not left relative: a relative url()
    // inside a CSS custom property resolves against the STYLESHEET that consumes the var
    // (e.g. /css/app.*.css), not the document, so it must become an absolute URL here.
    const rawBackgroundImageUrl = theApp.backgroundImageUrl || '';
    const safeBackgroundImageUrl =
      /^https:\/\//.test(rawBackgroundImageUrl) || /^\.\/assets\/modules\//.test(rawBackgroundImageUrl)
        ? new URL(rawBackgroundImageUrl, document.baseURI).href.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
        : '';
    document.documentElement.style.setProperty(
      '--quizwhiz-legacy-background-image',
      safeBackgroundImageUrl ? `url("${safeBackgroundImageUrl}")` : 'none'
    );
    // A custom (author-uploaded or https) background should fill the viewport;
    // the branded default background.png is authored for contain/top-left, so
    // leave the CSS var(..., fallback) defaults in place when there's no custom URL.
    if(safeBackgroundImageUrl){
      document.documentElement.style.setProperty('--quizwhiz-legacy-background-size', 'cover');
      document.documentElement.style.setProperty('--quizwhiz-legacy-background-position', 'center');
    } else {
      document.documentElement.style.removeProperty('--quizwhiz-legacy-background-size');
      document.documentElement.style.removeProperty('--quizwhiz-legacy-background-position');
    }

    // Same safe-URL rule as the background image, applied to the optional Welcome/GameOver side banner.
    const rawSideBannerUrl = theApp.sideBannerUrl || '';
    const safeSideBannerUrl =
      /^https:\/\//.test(rawSideBannerUrl) || /^\.\/assets\/modules\//.test(rawSideBannerUrl)
        ? new URL(rawSideBannerUrl, document.baseURI).href.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
        : '';
    document.documentElement.style.setProperty(
      '--quizwhiz-legacy-side-banner-image',
      safeSideBannerUrl ? `url("${safeSideBannerUrl}")` : 'none'
    );
    document.documentElement.classList.toggle('has-side-banner', !!safeSideBannerUrl);

    // Only accept plain hex colors; anything else leaves the CSS var unset so the
    // stylesheet's own var(..., fallback) default applies.
    const isSafeCssHexColor = value => /^#[0-9a-fA-F]{3,8}$/.test(value || '');
    [
      ['primaryColor', '--quizwhiz-legacy-primary-color'],
      ['secondaryColor', '--quizwhiz-legacy-secondary-color'],
      ['accentColor', '--quizwhiz-legacy-accent-color'],
    ].forEach(([stateKey, cssVarName]) => {
      if(isSafeCssHexColor(theApp[stateKey])){
        document.documentElement.style.setProperty(cssVarName, theApp[stateKey]);
      }
    });

    // set up resize listener
    theApp.$nextTick(() => {
      window.addEventListener('resize', theApp.onResize);
    });

    // set up listener for Individual and Team login principals
    onValue(theApp.usersRef, (snapshot) => {
      theApp.updateUsers(snapshot.val() ? theApp.mapUsersSnapshot(snapshot.val()) : []);
    })

    // set up listener for rounds 
    onValue(theApp.roundsRef, (snapshot) => {
      if(snapshot.val()){
        let updatedRounds = Object.entries(snapshot.val()).map(entry => {
          return {
            ...entry[1]
          }
        });
        theApp.updateRounds(updatedRounds)

        // close entirely when no round's schedule currently covers now
        theApp.updateCurrentRound(theApp.findActiveRoundId(updatedRounds));

        theApp.loadDetails = true;
      }else{
        theApp.updateRounds([])
        theApp.updateCurrentRound(null)
      }
    })

    // set up listener for durable operator state (gate + active-round override) written by the Admin panel
    onValue(theApp.operatorStateRef, (snapshot) => {
      const operatorState = snapshot.val() || {};
      theApp.updateGameEnabled(operatorState.gameEnabled !== false);
      theApp.updateActiveRoundId(
        operatorState.activeRoundId === undefined ? null : operatorState.activeRoundId
      );
      theApp.reevaluateCurrentRound();
    })

    // re-check round open/close state on a timer, independent of RTDB writes
    theApp.roundCheckIntervalId = window.setInterval(theApp.reevaluateCurrentRound, 10000);
  },
  beforeUnmount(){
    const theApp = this;
    window.removeEventListener('resize', theApp.onResize);
    window.clearInterval(theApp.roundCheckIntervalId);
  },
  data(){
    return {
      loadDetails: false,
      defaultLogoUrl,
      roundCheckIntervalId: null,
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style>
  #logoContainer{
    position: absolute;
    right: 10px;
    top: 20px;
  }

  #logo{
    width: 125px;
    height: auto;
  }

  #appContent{
    width: 100%;
    height: calc(100vh - 150px);
    margin: 0 auto;
/*    padding: 30px 0px;*/
    position: fixed;
    left: 0;
    right: 0;
    top: 150px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: rgba(0,0,0,.65);
    line-height: 1.3em;
    z-index: 51; /* MAY BE ABLE TO REMOVE THIS WHEN CHANGING NAVBAR DISPLAY TO HAMBURGER MENU ON SMALLER VIEWPORTS */
  }

  #detailsBanner{
    font-size: 24px;
    font-weight: bold;
    padding: 10px 0px;
    max-height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

/*  @media screen and (max-width: 496px){
    #appContent{
      width: 90%;
    }
  }*/

  @media screen and (max-width: 1023px){
    #appContent{
      height: calc(100vh - 100px);
      top: 100px;
    }
  }
</style>
